export type TValidDiplomaCredentials = 'CDOS' | 'TASC' | 'SACC';

export interface ICredential {
  human: TValidDiplomaCredentials;
  checkbox: {
    isIndeterminate: boolean;
  };
}

export const PlannedDiplomaCredentials = {
  tasc: {
    human: 'TASC',
    checkbox: {
      isIndeterminate: true,
    },
  } as ICredential,
  cdos: {
    human: 'CDOS',
    checkbox: {
      isIndeterminate: true,
    },
  } as ICredential,
  sacc: {
    human: 'SACC',
    checkbox: {
      isIndeterminate: true,
    },
  } as ICredential,
};
